import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientNextEngineLinkSimple } from "api/sms-api";
import { CustomError } from "errors/errors";

interface ClientLinkState {
  clientNextEngineLink: ClientNextEngineLinkSimple;
  clientNextEngineLinkLoading: boolean;
  error?: CustomError;
}

export const initialState: ClientLinkState = {
  clientNextEngineLinkLoading: false,
  clientNextEngineLink: { id: "", clientId: "" },
};

export const slice = createSlice({
  initialState,
  name: "ClientLink",
  reducers: {
    nextEngineAuthorizeError: (
      state: any,
      action: PayloadAction<CustomError>
    ) => {
      state.error = action.payload;
      state.clientNextEngineLinkLoading = false;
    },
    nextEngineAuthorizeStart: (state: any) => {
      state.clientNextEngineLinkLoading = true;
    },
    nextEngineAuthorizeSuccess: (
      state: any,
      action: PayloadAction<ClientNextEngineLinkSimple>
    ) => {
      state.clientNextEngineLink = action.payload;
      state.clientNextEngineLinkLoading = false;
    },
  },
});

export const {
  nextEngineAuthorizeStart,
  nextEngineAuthorizeSuccess,
  nextEngineAuthorizeError,
} = slice.actions;

export default slice.reducer;
